// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3vwnE","signatureButtonsRight":"ModalSign_signatureButtonsRight__21FIl"};